import mobx from 'mobx'
import LinkedAccountsManagerState from 'components/LinkedAccountsManager/LinkedAccountsManagerState'
import FlashMessageStore from 'components/FlashMessages/FlashMessageStore'
import encryptedStorage from 'misc/encryptedLocalStorage'
import storage, { storageSupported } from 'misc/localStorage'
import TaxfyleAPI from 'misc/TaxfyleAPI'
import { retryOnNetworkFailure } from '../utils/errorUtil'
import AuthStore from './AuthStore'
import ProjectStore from './ProjectStore'
import UserStore from './UserStore'
import MessageStore from './MessageStore'
import CouponStore from './CouponStore'
import DocumentStore from './DocumentStore'
import EventStore from './EventStore'
import BillingStore from './BillingStore'
import LinkedAccountStore from './LinkedAccountStore'
import ProjectDetailsStore from './ui/ProjectDetailsStore'
import ProjectWizardStore from './ui/ProjectWizardStore'
import RateProjectStore from './ui/RateProjectStore'
import DocumentsScreenStore from './ui/DocumentsScreenStore'
import SoundStore from './ui/SoundStore'
import DesktopNotificationStore from './ui/DesktopNotificationStore'
import CouponsScreenStore from './ui/CouponsScreenStore'
import ProfileEditorStore from './ui/ProfileEditorStore'
import ProjectsScreenStore from './ui/ProjectsScreenStore'
import IntercomStore from './ui/IntercomStore'
import BillingScreenStore from './ui/BillingScreenStore'
import GettingStartedStore from './ui/GettingStartedStore'
import ChangeEmailDialogStore from './ui/ChangeEmailDialogStore'

// let's see how this pans out.
mobx.useStrict(true)

// WARNING: Changing this will invalidate everything that was
// saved with a previous password.
const storagePassword = '9264P&%oCPyk!U){r<mqc?C8yI]71Q'

export class RootStore {
  constructor () {
    this.storage = storageSupported() ? encryptedStorage(storagePassword) : storage
    const makeOpts = () => ({ rootStore: this, storage: this.storage })
    mobx.runInAction(() => {
      this.authStore = new AuthStore(makeOpts())
      this.api = new TaxfyleAPI({ authStore: this.authStore })

      this.documentStore = new DocumentStore(makeOpts())
      this.userStore = new UserStore(makeOpts())
      this.messageStore = new MessageStore(makeOpts())
      this.projectStore = new ProjectStore(makeOpts())
      this.linkedAccountStore = new LinkedAccountStore(makeOpts())
      this.couponStore = new CouponStore(makeOpts())
      this.eventStore = new EventStore(makeOpts())
      this.billingStore = new BillingStore(makeOpts())

      this.projectDetailsStore = new ProjectDetailsStore(makeOpts())
      this.projectWizardStore = new ProjectWizardStore(makeOpts())
      this.rateProjectStore = new RateProjectStore(makeOpts())
      this.projectsScreenStore = new ProjectsScreenStore(makeOpts())
      this.documentsScreenStore = new DocumentsScreenStore(makeOpts())
      this.soundStore = new SoundStore(makeOpts())
      this.desktopNotificationStore = new DesktopNotificationStore(makeOpts())
      this.linkedAccountsManager = new LinkedAccountsManagerState(makeOpts())
      this.couponsScreenStore = new CouponsScreenStore(makeOpts())
      this.flashMessageStore = new FlashMessageStore(makeOpts())
      this.profileEditorStore = new ProfileEditorStore(makeOpts())
      this.intercomStore = new IntercomStore(makeOpts())
      this.billingScreenStore = new BillingScreenStore(makeOpts())
      this.gettingStartedStore = new GettingStartedStore(makeOpts())
      this.changeEmailDialogStore = new ChangeEmailDialogStore(makeOpts())
    })
  }

  retryOnNetworkFailure (fn) {
    const promise = retryOnNetworkFailure(fn)
    promise.retryMessage = (msg) => (
      promise.firstRetry(() => this.flashMessageStore.create(msg))
    )

    promise.recoveredMessage = (msg) => (
      promise.recovered((message) => message.done(msg).show().autoDismiss())
    )

    promise.networkIssueMessage = (msg) => (
      promise.doneRetrying((_, message) => {
        message.failed(msg).show().autoDismiss()
        return false
      })
    )

    return promise
      .retryMessage('Having network issues, trying again...')
      .recoveredMessage('Connectivity appears to have been restored.')
      .networkIssueMessage('Unable to connect to the server, are you connected to the Internet?')
  }
}

export default new RootStore()



// WEBPACK FOOTER //
// ./src/client/store/index.js